import * as prismic from "@prismicio/client";

interface GetPrismicDocumentParams {
    repoUrl: string;
    documentType: string;
}

/** Build a Prismic client from store.prismic_api_endpoint (CDN API URL). */
export const createPrismicClientFromEndpoint = (apiEndpoint: string) => {
    const hostname = new URL(apiEndpoint).hostname;
    const repoName = hostname.split(".")[0];
    if (!repoName) {
        throw new Error("Invalid Prismic API endpoint");
    }
    const endpoint = prismic.getRepositoryEndpoint(repoName);
    return prismic.createClient(endpoint);
};

export const getPrismicDocument = async ({
    repoUrl,
    documentType,
}: GetPrismicDocumentParams): Promise<string | null> => {
    try {
        const client = createPrismicClientFromEndpoint(repoUrl);
        const documents = await client.getByType(documentType);

        if (!documents?.results?.length) {
            console.warn(`No "${documentType}" documents found`);
            return null;
        }

        return documents?.results?.[0].id;
    } catch (error) {
        console.error(`Error fetching "${documentType}" from Prismic:`, error);
        return null;
    }
};

/**
 * Fetch Theme custom type and return its `variables` SCSS blob
 * (same field TLP writes into `_variables.scss`).
 */
export const getPrismicThemeVariables = async (
    apiEndpoint: string,
): Promise<string | null> => {
    try {
        const client = createPrismicClientFromEndpoint(apiEndpoint);
        const documents = await client.getByType("theme");
        const variables = documents?.results?.[0]?.data?.variables;

        if (typeof variables !== "string" || !variables.trim()) {
            console.warn('No Theme "variables" field found in Prismic');
            return null;
        }

        return variables;
    } catch (error) {
        console.error("Error fetching Theme from Prismic:", error);
        return null;
    }
};
